module.exports = __webpack_public_path__ + "media/application/images/ui/radio-1845b23de10960600379882749649c72.png";